import { BaseResponse, DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type ConfigurationTypeGetListRequest = GetListRequest<ConfigurationTypeGetListRequestFilter>;
export type ConfigurationTypeGetListResponse = GetListResponse<ConfigurationType>;
export type ConfigurationTypeDeleteRequest = DeleteRequest;

export interface ConfigurationTypeGetListRequestFilter {
  typeName?: string | null;

  /** @format int64 */
  refOrganization_Id?: number | null;
}

export interface ConfigurationType {
  typeName: string;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  refOrganization_Id?: number | null;
  isVisibleToOrg?: boolean | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface ConfigurationTypeGetByIdResponse extends BaseResponse {
  data: {
    typeName: string;
    configurations: Configuration[] | null;

    /** @format int64 */
    sortOrder?: number | null;

    /** @format int64 */
    refOrganization_Id?: number | null;
    isVisibleToOrg?: boolean | null;

    /** @format int64 */
    id?: number;

    /** @format byte */
    system_RowVersion?: string | null;
  }
}

export interface Configuration {
  keyName?: string | null;
  value?: string | null;

  /** @format int64 */
  refConfigType_Id?: number | null;
  name?: string | null;
  description?: string | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  refOrganization_Id?: number | null;
  isVisibleToOrg?: boolean | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
  isActive?: boolean;
}

export interface ConfigurationTypeUpdateRequest {
  typeName: string;
  configurations: Configuration[] | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  refOrganization_Id?: number | null;
  isVisibleToOrg?: boolean | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}
